import { createComponent } from '@carvana/merch-components';

export const YourTermsContainer = createComponent('div', {
  className:
    'flex flex-col items-start justify-center gap-2xl self-stretch rounded-xl bg-background-medium p-3xl px-2xl'
});

export const Header = createComponent('div', {
  className: 'text-text-inverse t-heading-xl'
});

export const Terms = createComponent('div', {
  className:
    'flex w-full flex-col items-start justify-center gap-xl sm:flex-row sm:flex-wrap sm:justify-start sm:gap-x-3xl'
});

export const TermItem = createComponent('div', {
  className:
    'flex flex-col items-start justify-center gap-sm self-stretch min-w-[130px]'
});

export const Label = createComponent('div', {
  className: 'flex items-center gap-sm'
});

export const LabelTypography = createComponent('span', {
  className: 'text-text-inverse t-label-xs'
});

export const Text = createComponent('div', {
  className: 'text-text-inverse t-heading-2xl'
});
